import { Subtitle, SubtitleSection } from "chq";
import updatedSection, { sectionModifications } from "./updatedSection";

const updateSubtitlesSectionsPositionByRange = (
  subtitles: Subtitle[],
  timeAdjustment: number,
  handleUpdateData: (newData: Record<string, any>) => void,
  startTime: number,
  endTime: number
): Record<string, any> => {
  let modifications = {};
  const updatedSubtitles = subtitles.map(subtitle => {
    const updatedSections: SubtitleSection[] = subtitle.sections?.map(section => {
      if (section.startTime >= startTime && section.endTime <= endTime) {
        const sectionMods = sectionModifications(section, timeAdjustment);
        modifications = { ...modifications, ...sectionMods };
        return updatedSection(section, timeAdjustment);
      }
      return section;
    }) || [];
    return { ...subtitle, sections: updatedSections };
  });

  handleUpdateData({ subtitles: updatedSubtitles });
  return modifications;
};

export default updateSubtitlesSectionsPositionByRange;
